/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';

/**
 * Inner dependencies.
 */
import Accordion from '../../../../components/Accordion';
import blockInfo from '../constants';
const { hookPrefix, layouts } = blockInfo;

addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-content`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/content`,
	( content, props ) => {
		const { attributes, setAttributes, updateInnerBlocks } = props;
		const { layout } = attributes;
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<Accordion tabs={ [
					{
						name: 'testimonial-item',
						initialOpen: true,
						label: () => {
							return __( 'Testimonial Item' );
						},
						cb: () => {
							return <>
								{ layouts && <div className="gutenify-template-browser">
									<h2>Templates</h2>

									<ul>
										{ layouts.map( ( template ) => {
											let classnames = 'gutenify-template-browser-item';
											if ( layout === template.name ) {
												classnames += ' gutenify-template-browser-item-active';
											}
											return <li className={ classnames } key={ template.name }>
												<button className={ `gutenify-template-browser-selector` } onClick={ () => {
													const data = {
														layout: template.name,
														ratingAlign: template.ratingAlign,
														imageAlign: template.imageAlign,
														titleAlign: template.titleAlign,
													};
													setAttributes( data );
													updateInnerBlocks( template );
												} }>
													<img src={ `${ window.gutenify_block_data.plugin_directory_url }/assets/images/testimonial-layouts/${ template.name }.png` } alt={ template.name } />
													<small>{ template.label }</small>
												</button></li>;
										} ) }
									</ul>
								</div> }
							</>;
						},
					},
				] } />
			</Fragment>,
		];
	}
);
